<template>
  <div class="w-full px-4 sm:px-6 lg:px-8">
    <div class="sm:flex sm:items-center">
      <div class="flex items-start justify-between sm:flex-auto">
        <h1 class="text-xl font-semibold text-gray-900">Allow List</h1>
        <RouterLink
          class="bg-primary text-primary-fg rounded-full px-3 py-2 text-sm"
          :to="
            activeTab === 'anpr'
              ? { name: 'createAllowlistEntry' }
              : { name: 'createKeypadCode' }
          "
        >
          {{ activeTab === "anpr" ? "Add Entry" : "Add Keypad Code" }}
        </RouterLink>
      </div>
    </div>

    <!-- Segmented Control -->
    <div class="mt-8">
      <BaseSegmentedControl
        v-if="isDigitalArrivals && isKeypad"
        v-model="activeTab"
        :options="tabOptions"
      />
    </div>

    <!-- Content based on active tab -->
    <div class="mt-8 flex flex-col">
      <RouterView />
    </div>
  </div>
</template>

<script setup lang="ts">
const router = useRouter();
const route = useRoute();

const KEYPAD_ROUTES = ["keypadCodes", "createKeypadCode", "keypadCodeInstance"];

// Tab state lives in the URL: /allow-list/anpr and /allow-list/keypad.
const activeTab = computed({
  get: () =>
    KEYPAD_ROUTES.includes(route.name as string) ? "keypad-codes" : "anpr",
  set: (tab: string) =>
    router.push({
      name: tab === "keypad-codes" ? "keypadCodes" : "allowlistEntries",
    }),
});

const tabOptions = [
  { label: "ANPR", value: "anpr" },
  { label: "Keypad", value: "keypad-codes" },
];

const isDigitalArrivals = useIsDigitalArrivals();
const isKeypad = useIsKeypad();
const { data: sites } = useSites();

// Land the base route on the first enabled tab, and bounce direct URLs off
// tabs the site's feature flags hide. No-op until the sites query resolves,
// or a hard reload would bounce legitimate users.
watchEffect(() => {
  if (!sites.value) return;
  if (!isDigitalArrivals.value && !isKeypad.value) {
    router.replace({ name: "bookings" });
  } else if (route.name === "allowlist") {
    router.replace({
      name: isDigitalArrivals.value ? "allowlistEntries" : "keypadCodes",
    });
  } else if (activeTab.value === "anpr" && !isDigitalArrivals.value) {
    router.replace({ name: "keypadCodes" });
  } else if (activeTab.value === "keypad-codes" && !isKeypad.value) {
    router.replace({ name: "allowlistEntries" });
  }
});
</script>
